import Utils from '../../../Utils';

const isMissing = value => value === undefined || value === null;

// Swim time is what the load metrics use. Records saved before manual workouts stored it
// only carry the training duration, so show that instead of a blank cell. An explicit
// 0/0 swim time is a real value and is not replaced.
export const getPerformanceDuration = workout => {
    const hasSwimTime =
        !isMissing(workout.swimmingDurationMin) || !isMissing(workout.swimmingDurationSec);

    return hasSwimTime
        ? Utils.formatDuration(workout.swimmingDurationMin, workout.swimmingDurationSec)
        : Utils.formatDuration(workout.trainingDurationMin, workout.trainingDurationSec);
};
